// extracted by mini-css-extract-plugin
export default {"formLabel":"styles_formLabel__wUqqt"};